import React from 'react';
import PageTitle from '../../layouts/PageTitle';
import CronJobMonitorTable from './CronJobMonitorTable';

const CronJobMonitor = () => (
  <>
    <PageTitle activeMenu="Cron Job Monitor" motherMenu="Admin" />
    <div className="row">
      <CronJobMonitorTable />
    </div>
  </>
);

export default CronJobMonitor;
